const createHeaders =  (headers) => {
  const allHeaders =  []
  headers.forEach( header => {
    allHeaders.push( { 
      text: header.text,
      sortable: true,
      value: header.value,
    })
  })
  return allHeaders
}
const createNewTableInfo = ( name , headers ) => {
   return {
    name,
    tData: [],
    display: false,
    headers: createHeaders( headers ),
  }
}
const getDefaultState = () => {
  return {
    tableData: [
      createNewTableInfo('PRetailer', [ 
        { 
          text: 'Merchant ID', 
          value: 'MerchantID'
        }, 
        { 
          text: 'Merchant Name', 
          value: 'MerchantName'
        },
        {
          text: 'Retailer ID',
          value: 'RetailerID'
        },
        {
          text: 'Retailer Name',
          value: 'RetailerName'
        },
        {
          text: 'PRetailerID',
          value: 'ID'
        },
        {
          text: 'pRetailer Name',
          value: 'Name'
        }
      ]),
      createNewTableInfo('Retailer', [ 
        { 
          text: 'Merchant ID', 
          value: 'MerchantID'
        }, 
        { 
          text: 'Merchant Name', 
          value: 'MerchantName'
        },
        {
          text: 'Retailer ID',
          value: 'ID'
        },
        {
          text: 'Retailer Name',
          value: 'Name'
        }
      ]),
      createNewTableInfo('Merchant', [ 
        { 
          text: 'Merchant ID', 
          value: 'ID'
        }, 
        { 
          text: 'Merchant Name', 
          value: 'Name'
        },
      ]),
    ],
    tableHeader: '',
    tableStatus: ''
  }
}

export default {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    SET_PRETAILERS: function({ commit }){
      if (!this.state.search.pRetailers) return
      const data = this.state.search.searchRes.filter( item => {
        return item.vo == 'pretailer'
      })
      commit('setPRetailers', data)
    },
    SET_RETAILERS: function({ commit }){
      if (!this.state.search.retailers) return
      const data = this.state.search.searchRes.filter( item => {
        return item.vo == 'retailer'
      })
      commit('setRetailers', data)
    },
    SET_MERCHANTS: function({ commit }){
      if (!this.state.search.merchants) return
      const data = this.state.search.searchRes.filter( item => {
        return item.vo == 'merchant'
      })
      commit('setMerchants', data)
    },
    TABLE_DATA_RESET: ({ commit }) => {
      commit('reset')
    },
    SET_TABLE_CARD_HEADER: ({ commit }, data) => {
      commit('setTableCardHeader', data)
    }
  },
  getters: {
  },
  mutations: {
    reset: function(state) {
      Object.assign(state, getDefaultState())
    },
    setTableCardHeader: ( state, data ) => {
      state.tableHeader = data.search,
      state.tableStatus = data.status
    },
    setPRetailers: ( state, data ) => {
      state.tableData[0].tData = data
      state.tableData[0].display = true      
    },
    setRetailers: ( state, data ) => {
      state.tableData[1].tData = data
      state.tableData[1].display = true
    },
    setMerchants: ( state, data ) => {
      state.tableData[2].tData = data
      state.tableData[2].display = true
    }
  }
}
